const unparsedLinkRegExp = new RegExp(/\[.*\]\s*\({1}http.*[^)]\)/, 'gmi');
const splitLinkRegExp = new RegExp(/\]\s*\(/, 'gmi');

const buildHref = (title = 'Click here', href) =>
  `<a href=${href}>${title}</a>`;

const parseBody = body => {
  let parsedBody = body;
  const unparsedLinks = parsedBody.match(unparsedLinkRegExp) || [];

  if (unparsedLinks.length) {
    unparsedLinks.forEach(match => {
      let [title, href] = match.split(splitLinkRegExp);
      title = title.replace('[', '');
      href = href.replace(')', '');
      parsedBody = parsedBody.replace(match, buildHref(title, href));
    });
  }

  return parsedBody;
};

export default parseBody;
